import React, { useState } from "react";
import "./FaqSection.css";

const faqs = [
  {
    id: 1,
    question: "When should I use a facial oil?",
    answer:
      "Facial oils are best applied as the last step in your skincare routine, after serums and moisturizers. You can use them morning and/or night depending on your skin's needs.",
  },
  {
    id: 2,
    question: "Can this product be used all over your body?",
    answer:
      "Yes! Our facial oil is gentle enough to be used on the body as well. It works great on dry patches, elbows, and even hair ends for extra nourishment.",
  },
  {
    id: 3,
    question: "Can I use the oil with my regular moisturizer?",
    answer:
      "Absolutely. Apply your moisturizer first, then seal it in with a few drops of the facial oil. This helps lock in hydration and boosts the effectiveness of both products.",
  },
  {
    id: 4,
    question: "Can I use the oil morning and night?",
    answer:
      "Yes, you can use our facial oil twice daily. In the morning, use 2–3 drops. At night, you can be a bit more generous to allow deeper overnight absorption.",
  },
  {
    id: 5,
    question: "Is this oil suitable for all skin types?",
    answer:
      "Our formula is designed to work with all skin types including oily, combination, dry, and sensitive skin. The lightweight texture absorbs quickly without clogging pores.",
  },
  {
    id: 6,
    question: "How many drops should I use per application?",
    answer:
      "We recommend starting with 2–4 drops per application. Warm the oil between your palms and gently press it onto clean skin. Adjust based on your skin's preference.",
  },
];

const FaqSection = () => {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="faq-section">
      <h2 className="faq-heading">Got questions? We&rsquo;ve got answers</h2>

      <div className="faq-body">
        {/* Left Accordion */}
        <div className="faq-left">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className={`faq-item ${openId === faq.id ? "faq-item--open" : ""}`}
            >
              <button
                className="faq-question"
                onClick={() => toggle(faq.id)}
                aria-expanded={openId === faq.id}
              >
                <span>{faq.question}</span>
                <span className="faq-icon">
                  {openId === faq.id ? "−" : "+"}
                </span>
              </button>
              <div className="faq-answer-wrapper">
                <div className="faq-answer">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Right Image */}
        <div className="faq-right">
          <div className="faq-image-circle">
            <img
              src="/images/newimage5.webp"
              alt="FAQ illustration - skincare products"
              className="faq-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;